module.exports = __webpack_public_path__ + "img/图层 733 1@2x.74edd6b2.png";